import FlexcarIn75SecondsVideo from '@/common/components/flexcar-in-75-seconds-video';

export default function FlexcarIn75SecondsTile() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-start overflow-hidden rounded-[16px] bg-flexcar-neutral10 p-6 shadow-shadow30 md:p-2">
      <p className="homepage-subhead1 mb-4 w-full text-left font-semibold text-white max-[334px]:text-[21px] max-[304px]:text-[20px] min-[640px]:max-[644px]:text-[21px] md:hidden min-[1024px]:max-[1083px]:text-[21px] min-[1364px]:max-[1393px]:text-[21px]">
        Flexcar in 75 seconds.
      </p>

      <FlexcarIn75SecondsVideo
        roundedPlayer={16}
        aspect={4 / 3}
        className="h-full w-full"
        fitStrategy="cover"
      />

      <div className="w-full md:px-4 md:pb-4 md:pt-6">
        <p className="homepage-subhead1 hidden w-full text-left font-semibold text-white max-[334px]:text-[21px] max-[304px]:text-[20px] min-[640px]:max-[644px]:text-[21px] md:block min-[1024px]:max-[1083px]:text-[21px] min-[1364px]:max-[1393px]:text-[21px]">
          Flexcar in 75 seconds.
        </p>

        <p className="body-tight mt-4 w-full text-left text-white md:mt-2">
          Once you Flex, you&apos;ll never buy a car again.
        </p>
      </div>
    </div>
  );
}
